// we default to English for now, at some point we would request the local from an API

const en = {
  locale: 'en-EN',
  messages: {
    counter: 'Counter',
    clickMe: 'Click Me',
    multipliedValue: 'Multiplied Value',
    uploadExelFile: 'Supported file type: .xlsx format, please use',
    jobStatus: 'Job Status',
    errorModalHeader: 'Errors',
    noDatatoShow: 'No records available',
    detailedView: 'Detailed View'
  }
};

export default en;
